import { Component, Prop, Vue } from 'vue-property-decorator'

import { BootstrapImage } from '../../../dsl/front'

/**
 * @author Javlon Khalimjonov <javlon.khalimjonov@movecloser.pl>
 */
@Component<ContactLocationTabUI>({
  name: 'ContactLocationTabUI',
  components: {
    BootstrapImage
  },

  template: `
    <section>
      <div class="container">
        <div class="row justify-content-center">
          <div class="contact__location">
            <iframe :src="location" frameborder="0"></iframe>
          </div>
        </div>
      </div>
    </section>
  `
})
export class ContactLocationTabUI extends Vue {
  //
  @Prop({ type: String, required: true })
  public readonly location!: string
}
